import { gql } from "@apollo/client";

export const MUTATION_DISCOUNT_CREAT = gql`
  mutation merchantCreateDiscountItem(
    $start_date: String!
    $end_date: String!
    $data: [ItemDiscountInput]
  ) {
    merchantCreateDiscountItem(
      start_date: $start_date
      end_date: $end_date
      data: $data
    )
  }
`;

export const MUTATION_DISCOUNT_UPDATE = gql`
  mutation merchantUpdateDiscount(
    $start_date: String!
    $end_date: String!
    $data: [ItemDiscountInput]
    $campaign_id: Int!
    $delete_id: [Int]
  ) {
    merchantUpdateDiscount(
      start_date: $start_date
      end_date: $end_date
      data: $data
      campaign_id: $campaign_id
      delete_id: $delete_id
    )
  }
`;

export const QUERY_DISCOUNT_ITEM = gql`
  query merchantDiscountItem($campaign_id: Int!) {
    merchantDiscountItem(campaign_id: $campaign_id)
  }
`;

export const QUERY_DISCOUNT = gql`
query merchantDiscountItemCampaign($offset: Int=0, $limit: Int=10){
  merchantDiscountItemCampaign(offset: $offset, limit: $limit){
    id
    start_date
    end_date
    actived
  }
}
`